var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCmdShowImpactOfChange24(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.5,20H.5a.5.5,0,0,1-.435-.746L5.636,9.4l.87.492L1.357,19H17.641L9.065,3.89l.87-.493,9,15.857A.5.5,0,0,1,18.5,20Z",
    className: "aw-theme-iconOutline",
    fill: "#464646"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.154,7.143a.5.5,0,1,0,.707.707l1.992-1.992a.5.5,0,0,0,0-.707l-2-2a.5.5,0,0,0-.707.707L22.289,5H13V6h9.3Z",
    className: "aw-theme-iconOutline",
    fill: "#464646"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.854,9.15a.5.5,0,0,0-.707.707L22.289,11H16v1h6.3l-1.143,1.143a.5.5,0,1,0,.707.707l1.992-1.992a.5.5,0,0,0,0-.707Z",
    className: "aw-theme-iconOutline",
    fill: "#464646"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.854,15.15a.5.5,0,0,0-.707.707L22.289,17H19v1h3.3l-1.143,1.143a.5.5,0,1,0,.707.707l1.992-1.992a.5.5,0,0,0,0-.707Z",
    className: "aw-theme-iconOutline",
    fill: "#464646"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCmdShowImpactOfChange24);
export default __webpack_public_path__ + "static/media/cmdShowImpactOfChange24.c981c4fe59b0bbb1943e52bffb20a410.svg";
export { ForwardRef as ReactComponent };